import React from 'react';
import { CheckIcon } from 'lucide-react';
import { foundingPlans } from '../../data/foundingOffer';
import { PlanPrice } from './PlanPrice';
import type { MembershipPlanId } from '../../types/practitionerSignup';
interface MembershipPlansProps {
  selectedPlan: MembershipPlanId | null;
  redirectingPlan: MembershipPlanId | null;
  onChoose: (planId: MembershipPlanId) => void;
}
export function MembershipPlans({
  selectedPlan,
  redirectingPlan,
  onChoose
}: MembershipPlansProps) {
  const busy = redirectingPlan !== null;
  return <ul className="grid gap-5 md:grid-cols-2 xl:grid-cols-4" data-id="element-472" data-mp="1ue3t1iow1wxv">
      {foundingPlans.map(plan => {
      const isSelected = selectedPlan === plan.id;
      return <li key={plan.id} className={`relative flex flex-col rounded-2xl px-6 py-7 ${plan.highlighted ? 'border-2 border-purple-600 bg-purple-50' : 'border border-purple-200 bg-white'}`} data-id="element-473" data-mp="23glj687nz9q5">
            {plan.highlighted && <span className="absolute -top-3 left-6 rounded-full bg-purple-700 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-white" data-id="element-474" data-mp="3g3klvts0jd7l">
                Most popular
              </span>}

            <h3 className="font-serif text-2xl text-charcoal" data-id="element-475" data-mp="3py2v1eg780ys">
              {plan.name}
            </h3>

            <p className="mt-1 text-sm text-charcoal/60" data-id="element-476" data-mp="2mv2n4p2glmp">
              {plan.seats}
            </p>

            <div className="mt-6" data-id="element-477" data-mp="7lo5m36q8u8m">
              <PlanPrice price={plan.price} priceSuffix={plan.priceSuffix} data-id="element-478" data-mp="7kwn9u254t0a" />
            </div>

            <ul className="mt-6 space-y-2.5" data-id="element-479" data-mp="cm2f7pnz8c8r">
              {plan.features.map(feature => <li key={feature} className="flex items-start gap-2.5 text-sm leading-relaxed text-charcoal/80" data-id="element-480" data-mp="hj2lo1oqnh0e">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-purple-700" data-id="element-481" data-mp="2jbgxqk4lpr8w" />

                  {feature}
                </li>)}
            </ul>

            <div className="mt-auto pt-8" data-id="element-482" data-mp="26czr3w2eq5g7">
              <button type="button" id={`choose-plan-${plan.id}`} data-plan-id={plan.id} onClick={() => onChoose(plan.id)} disabled={busy} aria-pressed={isSelected} className={`inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 py-3.5 text-sm font-semibold transition-colors duration-200 ease-out disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 ${plan.highlighted ? 'bg-purple-700 text-white hover:bg-purple-800 disabled:opacity-70 focus-visible:ring-offset-purple-50' : 'border border-charcoal/25 text-charcoal hover:border-purple-700 hover:text-purple-800 disabled:opacity-60 focus-visible:ring-offset-white'}`} data-id="element-483" data-mp="26e2i03zqc7w4">
                Choose {plan.name}
              </button>
            </div>
          </li>;
    })}
    </ul>;
}